import { ApiFetchState } from "@swiggy-private/payment-core";

export type CardBalanceState = {
    [key: string]: CardBalanceStateValue;
};

export type CardBalanceStateValue = {
    fetchState: ApiFetchState;
    balance: number;
};

export const defaultCardBalanceStateValue: CardBalanceStateValue = {
    fetchState: ApiFetchState.SUCCESS,
    balance: 0,
};

export enum GetCardBalanceActionTypes {
    REQUEST,
    SUCCESS,
    ERROR,
}

export type GetCardBalanceAction =
    | { type: GetCardBalanceActionTypes.REQUEST; name: string }
    | { type: GetCardBalanceActionTypes.SUCCESS; name: string; payload: Omit<CardBalanceStateValue, "fetchState"> }
    | { type: GetCardBalanceActionTypes.ERROR; name: string };

export function getCardBalanceReducer(state: CardBalanceState, action: GetCardBalanceAction): CardBalanceState {
    switch (action.type) {
        case GetCardBalanceActionTypes.REQUEST:
            return { ...state, [action.name]: { ...(state[action.name] ?? {}), fetchState: ApiFetchState.LOADING } };
        case GetCardBalanceActionTypes.SUCCESS:
            return {
                ...state,
                [action.name]: { ...(state[action.name] ?? {}), ...action.payload, fetchState: ApiFetchState.SUCCESS },
            };
        case GetCardBalanceActionTypes.ERROR:
            return { ...state, [action.name]: { ...(state[action.name] ?? {}), fetchState: ApiFetchState.ERROR } };
    }
}
